import { render, staticRenderFns } from "./SessionsNewFilters.vue?vue&type=template&id=474b11c2&scoped=true&"
import script from "./SessionsNewFilters.vue?vue&type=script&lang=js&"
export * from "./SessionsNewFilters.vue?vue&type=script&lang=js&"
import style0 from "./SessionsNewFilters.vue?vue&type=style&index=0&id=474b11c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474b11c2",
  null
  
)

export default component.exports